import { useTranslate } from '@ur-solutions/react-hooks'
import type { CellProps } from '@/components_deprecated';
import { Cell } from '@/components_deprecated'
import type { ActivitiesDynamicColumnDayReport } from '@/modules/activities/types.graphql'

interface SalaryCodeProps {
  report: ActivitiesDynamicColumnDayReport
  subColumn: boolean
  useExternalId: boolean
}
export const SalaryCode: React.JSX.CFC<SalaryCodeProps> = ({
  report,
  subColumn = false,
  useExternalId = false,
}) => {
  const translations = useTranslate({
    nSalaryCodes: ['common.n-salary-code', { n: 2 }],
  })
  const singleDataKey = useExternalId ? 'salaryId' : 'salaryName'
  if (subColumn) {
    return <>{report[singleDataKey]}</>
  }
  const data = useExternalId ? report['salaryIds'] : report['salaryNames']

  const display =
    data.length > 1
      ? translations.nSalaryCodes({ n: data.length })
      : data.length === 1
      ? data[0]
      : ''
  return <>{display}</>
}
interface SalaryCodeCellProps extends SalaryCodeProps, CellProps {}
export const SalaryCodeCell: React.FC<SalaryCodeCellProps> = ({
  narrow = true,
  centered = true,
  ...salaryCodeProps
}) => (
  <Cell narrow={narrow} centered={centered}>
    <SalaryCode {...salaryCodeProps} />
  </Cell>
)
